import React from "react";
import "./loader.css";
const Loader = () => {
  return (
    <div className="loader-main-div">
      <span class="loader" />
    </div>
  );
};

export default Loader;
